
  <router-outlet id="topOutlet" name="topOutlet"></router-outlet>
  <!-- CONTENT -->
  <div class="relative flex flex-col items-center" [@descriptinonExpanded]="standService.$onDescriptionExpanded | async" >
    <div class="container w-screen flex flex-1 h-full gap-x-6 mt-5 md:mt-[40px] pb-4" [class.collapsed]="standService.standLayout()?.lockCollapsed">
      <div class="flex flex-col flex-1 relative lg:max-w-[calc(100%-var(--infobar-width))]"
          [@routeAnimations]="routerAnimation">
        <router-outlet  id="standContent" #outlet="outlet"></router-outlet>
      </div>
      @if (showOverlay) {
        <info-bar class="company-info hidden lg:block" *renderIf="{mediaSelector:'gt-md'}"></info-bar>
      }
      @else{
        <info-bar class="company-info hidden lg:block z-40" *renderIf="{mediaSelector:'gt-md'}"></info-bar>
      }
    </div>
  </div>

